import {client} from './services/client'

export  const produits = {
    namespaced:true,
    state:{
        produits:[],
        oneproduits:[],
        totalpage:[],
        prodloading:true,
        overlay:true
    },
    mutations: {
        SET_PRODUIT (state,produits){
            state.produits = produits
        },
        SET_PRODUITLOADING (state,val){
            state.prodloading = val
        },SET_OVERLAY (state,val){
            state.overlay = val
        },
        SET_ONEPRODUIT (state,produits){
            state.oneproduits = produits
        },
        SET_TOTAL (state,total){
            state.totalpage = total
        },


    },
    actions: {
        getProduits({commit}){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/produits/get',
                })
                    .then((response)=>{
                        let produits = response.data.produits;
                        console.log(produits);
                        commit('SET_PRODUIT',produits)
                        commit('SET_PRODUITLOADING',false)

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        getPaginate({commit},page){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/produits/getPaginate/'+page,
                })
                    .then((response)=>{
                        let produits = response.data.produits;
                        let total = response.data.total;
                        console.log(produits);
                        commit('SET_PRODUIT',produits);
                        commit('SET_TOTAL',total);
                        commit('SET_PRODUITLOADING',false)
                         resolve(response);

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        getSearch({commit},str){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/produits/getSearch/'+str,
                })
                    .then((response)=>{
                        let produits = response.data.produits;
                        console.log("Search");
                        console.log(produits);
                        commit('SET_PRODUIT',produits);
                         resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        getOnceProduits({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/produits/getOnceProduits',
                    data:data,
                })
                    .then((response)=>{
                        let produits = response.data.produits;
                        commit('SET_ONEPRODUIT',produits);
                        resolve(response);
                        console.log(produits);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        getPharmaNotProduct({commit},data){
            commit('SET_OVERLAY',true);
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/produits/getPharmaNotProduct',
                    data:data,
                }).then((response)=>{
                        let produits = response.data.produits;
                        commit('SET_PRODUIT',produits);
                        commit('SET_OVERLAY',false);
                        resolve(response);
                        console.log('not produits');
                        console.log(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        setUpdateProduit({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/produits/update',
                    data:data,
                })
                    .then((response)=>{
                        let produits = response.data.produits;
                        commit('SET_PRODUIT',produits);
                        resolve(response);
                        console.log(produits);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        setProduit({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/produits/save',
                    data:data,
                })
                    .then((response)=>{
                        let produits = response.data.produits;
                        commit('SET_PRODUIT',produits);

                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        deleteProduit({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/produits/delete/'+id,
                })
                    .then((response)=>{
                        let produits = response.data.produits;
                        commit('SET_PRODUIT',produits);
                        console.log(produits);

                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },
    },
    getters: {
        getProduits: state  => {
            return state.produits
        },
        getOnceProduits: state  => {
            return state.oneproduits
        },

        getProdLoading: state  => {
            return state.prodloading
        },

    }
};
